<template>
  <v-app>
    <v-main>
      <!-- <NavBar :dir="dir" /> -->
      <!-- <p>{{ $t("hello") }} {{ $t("world") }}</p> -->
      <v-locale-provider rtl>
        <router-view />
      </v-locale-provider>
    </v-main>
  </v-app>
</template>

<script>
//import NavBar from "./components/NavBar.vue";
export default {
  name: "App",

  data: () => ({}),
  components: {
    //NavBar,
  },
  computed: {
    dir() {
      return this.$i18n.messages[this.$i18n.locale].dir;
    },
  },
};
</script>
<style>
@import "./assets/fonts.css";
body {
  font-family: tajawal;
}
</style>
